import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
let CrfModule = class CrfModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isLoading = false;
        this.xtokenModule = '';
        this.listArrayJci = [];
        this.filterListJci = [];
        this.jciErrorSetsTabOne = [];
        this.jciErrorSetsTabTwo = [];
        this.loadingJci = false;
        this.submitInfoDialog = false;
        this.submissionLoading = false;
        this.questionAnswer = [];
        this.touched = false;
        this.validationTabOne = false;
        this.validationTabTwo = false;
        this.isSubmitClick = false;
        this.errorMessage = '';
        this.isConfirmDraftCondition = '';
        this.jciFirstTab = {
            vendorOtherName: '',
            jobTypeName: ''
        };
        this.apiUserCrf = {};
        this.optionVendorJci = [];
        this.isAllowCreateCRFJci = null;
        this.validationRemarksJci = false;
    }
    get getLoadingJci() {
        return this.loadingJci;
    }
    get getJciErrorSetsTabOne() {
        return this.jciErrorSetsTabOne;
    }
    get getJciErrorSetsTabTwo() {
        return this.jciErrorSetsTabTwo;
    }
    get getFilterListJci() {
        return this.filterListJci;
    }
    ['setSubmissionLoading'](data) {
        this.submissionLoading = data;
    }
    get getSubmissionLoading() {
        return this.submissionLoading;
    }
    get getListJci() {
        return this.listArrayJci;
    }
    ['setLoadingJci'](data) {
        this.loadingJci = data;
    }
    ['setJciErrorSetsTabOne'](data) {
        this.jciErrorSetsTabOne = data;
    }
    ['editJciErrorSetsTabOne'](data) {
        if (this.jciErrorSetsTabOne.length != 0) {
            const index = this.jciErrorSetsTabOne
                .map((x) => {
                return x.field.name;
            })
                .indexOf(data);
            this.jciErrorSetsTabOne.splice(index, 1);
        }
    }
    ['setJciErrorSetsTabTwo'](data) {
        this.jciErrorSetsTabTwo = data;
    }
    ['editJciErrorSetsTabTwo'](data) {
        if (this.jciErrorSetsTabTwo.length != 0) {
            const index = this.jciErrorSetsTabTwo
                .map((x) => {
                return x.field.id;
            })
                .indexOf(data);
            if (index != -1) {
                this.jciErrorSetsTabTwo.splice(index, 1);
            }
        }
    }
    ['setXtokenModule'](data) {
        this.xtokenModule = data;
    }
    ['setFilterListJci'](data) {
        this.filterListJci = data;
    }
    ['setListJciClear']() {
        this.listArrayJci = [];
    }
    ['setListJci'](data) {
        this.listArrayJci = data;
    }
    ['getListJciModule'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/jciheader/monitoring/multifilter?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                globalSearch: params.globalSearch,
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    const users = axiosResponse;
                    this.context.commit('setListJci', users);
                    this.context.commit('setIsLoading', false);
                    this.context.commit('setIsanyIsAllowCreateCRFJci', users);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['downloadExcelJciList'](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/jciheader/monitoring/multifilterexcel?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                globalSearch: params.globalSearch,
                userLogin: String(params.employeeId),
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    window.open(response.data.result.content, '_self', 'download');
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    get getIsSubmitClick() {
        return this.isSubmitClick;
    }
    get getErrorMessage() {
        return this.errorMessage;
    }
    get getQuestionAnswer() {
        return this.questionAnswer;
    }
    get getValidationTabOne() {
        return this.validationTabOne;
    }
    get gettersValidationTabTwo() {
        return this.validationTabTwo;
    }
    get getTouched() {
        return this.touched;
    }
    ['setErrorMessage'](data) {
        this.errorMessage = data;
    }
    ['setIsSubmitClick'](data) {
        this.isSubmitClick = data;
    }
    ['resetStateJci']() {
        document.cookie = `expenditureDefault=${null}`;
        this.validationRemarksJci = false;
        this.jciFirstTab = {
            vendorOtherName: '',
            jobTypeName: ''
        };
        this.submissionLoading = false;
        this.loadingJci = false;
        this.optionVendorJci = [];
        this.isConfirmDraftCondition = '';
        this.questionAnswer = [];
        this.touched = false;
        this.validationTabOne = true;
        this.validationTabTwo = true;
        this.errorMessage = '';
        this.jciErrorSetsTabOne = [];
        this.jciErrorSetsTabTwo = [];
        this.isSubmitClick = false;
    }
    ['setQuestionAnswer'](data) {
        this.questionAnswer = data;
    }
    ['setTouched'](data) {
        this.touched = data;
    }
    ['setValidationTabTwo'](data) {
        this.validationTabTwo = data;
    }
    ['setValidationTabOne'](data) {
        this.validationTabOne = data;
    }
    get getIsconfirmDraftCondition() {
        return this.isConfirmDraftCondition;
    }
    ['setIsConfirmDraft'](data) {
        this.isConfirmDraftCondition = data;
    }
    get getJciFirstTab() {
        return this.jciFirstTab;
    }
    ['setJciFirstTab'](data) {
        this.jciFirstTab = data;
    }
    get getApiUserCrf() {
        return this.apiUserCrf;
    }
    ['setApiUserCrf'](data) {
        this.apiUserCrf = data;
    }
    ['callApiUserCrf']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/master/user?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.getData(apiUrl)
                    .then((response) => {
                    this.context.commit('setApiUserCrf', response.data.result.content);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    get getOptionVendorJci() {
        return this.optionVendorJci;
    }
    ['setOptionVendorJci'](data) {
        this.optionVendorJci = data;
    }
    ['callLookUpJci'](obj) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/jciheader/getlookup?ver=v1`;
            const params = {
                lookupKey: obj.lookupKey,
                userLogin: String(obj.employeeId),
                search: obj.searchParams
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    this.context.commit('setOptionVendorJci', axiosResponse);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    get getIsAllowCreateCRFJci() {
        return this.isAllowCreateCRFJci;
    }
    ['setIsanyIsAllowCreateCRFJci'](data) {
        const listIsAllowCreateCRFJci = data.data.map((item) => {
            return item.isAllowCreateCRF;
        });
        this.isAllowCreateCRFJci = listIsAllowCreateCRFJci.includes(true);
    }
    get getValidationRemarksJci() {
        return this.validationRemarksJci;
    }
    get getSubmitInfoDialogJci() {
        return this.submitInfoDialog;
    }
    ['setSubmitInfoDialogJci'](data) {
        this.submitInfoDialog = data;
    }
    ['setValidationRemarksJci'](data) {
        this.validationRemarksJci = data;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSubmissionLoading', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setLoadingJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setJciErrorSetsTabOne', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'editJciErrorSetsTabOne', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setJciErrorSetsTabTwo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'editJciErrorSetsTabTwo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setXtokenModule', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setFilterListJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setListJciClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setListJci', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'getListJciModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'downloadExcelJciList', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setErrorMessage', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsSubmitClick', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'resetStateJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setQuestionAnswer', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setTouched', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setValidationTabTwo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setValidationTabOne', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsConfirmDraft', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setJciFirstTab', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setApiUserCrf', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'callApiUserCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setOptionVendorJci', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfModule.prototype, 'callLookUpJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setIsanyIsAllowCreateCRFJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setSubmitInfoDialogJci', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfModule.prototype, 'setValidationRemarksJci', null);
CrfModule = __decorate([
    Module
], CrfModule);
export default CrfModule;
